import React from "react";

import icons from "./icons";

type Props = {
  id?: string;
  name: string;
  size?: string;
  className?: string;
  onClick?: () => void;
  tabIndex?: number;
};

const Icon = ({ id, name, size = "24px", className, onClick, tabIndex }: Props) => {
  const iconName = `Icon_${name}`;
  const IconComponent: React.FC<React.SVGAttributes<SVGElement>> = icons[iconName as keyof typeof icons];

  return <IconComponent id={id} style={{ width: size }} className={className} onClick={onClick} tabIndex={tabIndex} />;
};

export default Icon;
